import styles from "./style.module.scss";
import { Row, Col } from "antd";

const Header = () => {
  return (
      <Row justify="space-between" align="top">
        <Col span={12}>
        </Col>
        <Col span={12} />
      </Row>
  );
};

export default Header;
